/** What the viewer can do with a file, from its MIME type and name. */

export type FileKind = "pdf" | "image" | "video" | "audio" | "other";

const OFFICE = /\.(docx?|odt|rtf|pptx?|ppsx?|odp|xlsx?|ods)$/i;
const BY_EXTENSION: Record<string, FileKind> = {
  pdf: "pdf",
  png: "image", jpg: "image", jpeg: "image", gif: "image", webp: "image", avif: "image", bmp: "image", svg: "image",
  mp4: "video", m4v: "video", webm: "video", mov: "video", ogv: "video",
  mp3: "audio", m4a: "audio", aac: "audio", wav: "audio", ogg: "audio", oga: "audio", opus: "audio", flac: "audio", weba: "audio",
};
// Formats most browsers cannot draw even though they are image/* types.
const UNSUPPORTED_IMAGES = new Set(["image/tiff", "image/heic", "image/heif", "image/x-icon"]);

export function isOfficeName(name: string): boolean {
  return OFFICE.test(name);
}

export function fileKind(type: string, name: string): FileKind {
  const t = type.toLowerCase();
  if (t === "application/pdf") return "pdf";
  if (t.startsWith("image/")) return UNSUPPORTED_IMAGES.has(t) ? "other" : "image";
  if (t.startsWith("video/")) return "video";
  if (t.startsWith("audio/")) return "audio";
  const ext = name.split(".").pop()?.toLowerCase() ?? "";
  // A generic type (octet-stream) still opens when the extension is known.
  return BY_EXTENSION[ext] ?? "other";
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const KIND_LABEL: Record<FileKind, string> = {
  pdf: "Document",
  image: "Image",
  video: "Video",
  audio: "Audio",
  other: "File",
};
